import { ProductCheckpointListDTO } from '../product-checkpoint/product-checkpoint-list.dto';
import { TeamAccessDTO } from '../team/team-access.dto';
import { ProductTestAnswerListDTO } from '../product-test-answer/product-test-answer-list.dto';

export class ProductCheckpointQuestionDTO extends TeamAccessDTO {

    question: string;

    checkpoints: Array<ProductCheckpointListDTO>;

    answers: Array<ProductTestAnswerListDTO>;

}
